import { z } from "zod";

/** The password rule for every account (its own module: auth.ts and users.ts both use it). */
export const PASSWORD_MIN = 12;
export const password = z.string().min(PASSWORD_MIN).max(256);
